import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';

class ManufacturersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      aircraft_model_id: null,
      aircraft_models_list: [],
      aircraft_models: [],
     };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addAircraftModel = this.addAircraftModel.bind(this);
    this.deleteAircraftModel = this.deleteAircraftModel.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/fabricante/info/edicao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/fabricantes');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            aircraft_models_list: responseJson.data.aircraft_models_list,
            aircraft_models: responseJson.data.main.aircraft_models,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });
    });
  }


  edit(event) {
    event.preventDefault();
    var datasave = {
      id: this.state.id,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fabricante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });   
  }


  addAircraftModel(event) {
    event.preventDefault();
    var datasave = {
      id: this.state.aircraft_model_id,
      manufacturer_id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frota/editar/fabricante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });   
  }

  deleteAircraftModel(aircraft_model_id) {
    if (window.confirm('Tem certeza que deseja deletar esta frota desse fabricante?')) {
      var datasave = {
        id: aircraft_model_id,
        manufacturer_id: this.state.id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/frota/deletar/fabricante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });   
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar fabricante</h3>
      <Link to="/fabricantes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
          </div>
          <div className="col-md-6 form-group">
            <button type={'submit'} className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Editar fabricante</button>
          </div>
        </div>
      </form>
      <hr/>
      <h4>Adicionar frota</h4>
      <hr/>
      <form onSubmit={this.addAircraftModel}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Frota:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_id"
              value={this.state.aircraft_model_id}
              searchable={true}
              placeholder={'Selecionar ano'}
              onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
              options={this.state.aircraft_models_list}
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <button type={'submit'} className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Adicionar frota</button>
          </div>
        </div>
      </form>
      <hr/>
      <h4>Frotas</h4>
      <hr/>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Modelo</th>
            <th className="col-md-1 text-center">Ações</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.aircraft_models).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.aircraft_models[k].model}</td>
                <td className="text-center">
                  <button onClick={() => {self.deleteAircraftModel(self.state.aircraft_models[k].id)}} className='btn btn-sm btn-danger' alt='Deletar' title='Deletar'><i className="fa fa-fw fa-trash"></i></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default ManufacturersEdit;



// WEBPACK FOOTER //
// ./src/Components/Manufacturers/ManufacturersEdit.js